import { de, enUS } from 'date-fns/locale';
import type { FlatNamespace, TFunction } from 'i18next';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export type TranslationFunction = TFunction<FlatNamespace>;

export function useLocale(namespace?: FlatNamespace | FlatNamespace[]) {
    const { i18n, t } = useTranslation(namespace);
    const locale = i18n.language || 'de';

    const isLocaleReady = Object.keys(i18n).length > 0;

    const thousandSeparator = locale === 'de' ? '.' : `,`;
    const decimalSeparator = locale === 'de' ? `,` : '.';

    const currencyIsBefore = locale !== 'de';

    const monthNames = useMemo(() => {
        const formatter = new Intl.DateTimeFormat(locale, { month: 'long' });
        return Array.from({ length: 12 }, (_, i) => formatter.format(new Date(2020, i, 10)));
    }, [locale]);

    return {
        i18n,
        t,
        isLocaleReady,
        locale: i18n.language,
        thousandSeparator,
        decimalSeparator,
        currencyIsBefore,
        localeData: locale === 'de' ? de : enUS,
        monthNames,
    };
}
